<template>
  <svg viewBox="0 0 29.05 31.58" xmlns="http://www.w3.org/2000/svg">
    <g id="Calque_2" data-name="Calque 2">
      <g id="ƒŒƒCƒ_1" data-name="ƒŒƒCƒ„[ 1">
        <path
          class="cls-1"
          d="M26.65,8.08H17.31a1.14,1.14,0,0,0-1.14,1.14V22.36a1.14,1.14,0,0,0,1.14,1.14h9.34a1.14,1.14,0,0,0,1.14-1.14V9.22A1.14,1.14,0,0,0,26.65,8.08Zm-1.13,3.29H18.44v-1h7.08Z"
        />
        <path
          class="cls-2"
          d="M22.11,25.63a.64.64,0,0,0-.64.64v4.05H1.26V5.81H5.18a.64.64,0,0,0,.63-.64V1.26H21.47v4a.64.64,0,0,0,1.27,0V.62A.63.63,0,0,0,22.1,0H5.32a.62.62,0,0,0-.44.18L.19,4.75A.64.64,0,0,0,0,5.2V30.94a.64.64,0,0,0,.63.64H22.1a.64.64,0,0,0,.64-.64V26.27A.64.64,0,0,0,22.11,25.63ZM2.21,4.55,4.55,2.26V4.55Z"
        />
        <path
          class="cls-2"
          d="M26.78,9.73a.63.63,0,0,0-.63-.63H17.81a.63.63,0,0,0-.63.63V12a.63.63,0,0,0,.63.63h8.34a.63.63,0,0,0,.63-.63Zm-1.26,1.64H18.44v-1h7.08Z"
        />
        <path
          class="cls-2"
          d="M29.05,9.22a2.4,2.4,0,0,0-2.4-2.4H17.31a2.4,2.4,0,0,0-2.4,2.4V22.36a2.4,2.4,0,0,0,2.4,2.4h9.34a2.4,2.4,0,0,0,2.4-2.4ZM27.79,22.36a1.14,1.14,0,0,1-1.14,1.14H17.31a1.14,1.14,0,0,1-1.14-1.14V9.22a1.14,1.14,0,0,1,1.14-1.14h9.34a1.14,1.14,0,0,1,1.14,1.14Z"
        />
        <path class="cls-2" d="M19,14.4h-1a.63.63,0,1,0,0,1.26h1a.63.63,0,0,0,0-1.26Z" />
        <path class="cls-2" d="M26,14.4H25a.63.63,0,0,0,0,1.26h1a.63.63,0,1,0,0-1.26Z" />
        <path class="cls-2" d="M22.48,14.4h-1a.63.63,0,1,0,0,1.26h1a.63.63,0,0,0,0-1.26Z" />
        <path
          class="cls-2"
          d="M19,17.43h-1a.64.64,0,0,0-.64.63.64.64,0,0,0,.64.64h1a.64.64,0,0,0,.63-.64A.63.63,0,0,0,19,17.43Z"
        />
        <path
          class="cls-2"
          d="M26,17.43H25a.63.63,0,0,0-.63.63.64.64,0,0,0,.63.64h1a.64.64,0,0,0,.63-.64A.63.63,0,0,0,26,17.43Z"
        />
        <path
          class="cls-2"
          d="M22.48,17.43h-1a.63.63,0,0,0-.63.63.64.64,0,0,0,.63.64h1a.64.64,0,0,0,.63-.64A.63.63,0,0,0,22.48,17.43Z"
        />
        <path class="cls-2" d="M19,20.46h-1a.64.64,0,1,0,0,1.27h1a.64.64,0,0,0,0-1.27Z" />
        <path class="cls-2" d="M26,20.46H25a.64.64,0,0,0,0,1.27h1a.64.64,0,0,0,0-1.27Z" />
        <path class="cls-2" d="M22.48,20.46h-1a.64.64,0,0,0,0,1.27h1a.64.64,0,0,0,0-1.27Z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconSubmission',
};
</script>

<style scoped>
.cls-1 {
  fill: #f9802f;
}

.cls-2 {
  fill: #162b46;
}
</style>
